var map = {
	"./ar/contact.json": 7978,
	"./de/contact.json": 3601,
	"./en/contact.json": 7053,
	"./es/contact.json": 8382,
	"./fr/contact.json": 1515,
	"./pt/contact.json": 415,
	"./ru/contact.json": 9357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1648;